import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import DataWrapper from '../../../principal/containers/DataWrapper';
import MovimentacaoStore from "../stores/MovimentacaoStore";
import Footer from "../../../comum/components/Footer";
import {FiltrosMovimentacao} from "../components/FiltrosMovimentacao";
import {TabelaMovimentacao} from "../components/TabelaMovimentacao";
import {Container, Row} from "reactstrap";
import JanelaFiltros from '../../../comum/components/JanelaFiltros';
import CamposExibicaoStore from '../stores/CamposExibicaoStore';
import ModalAviso from '../../../comum/components/ModalAviso'
import IconButton from '../../../comum/components/IconButton';
import FooterOptions from '../../../comum/components/FooterOptions';
import { makePDF } from '../../../../utils/formatar';
import FooterContent from '../../../comum/components/FooterContent';
import LoadingImage from "../../../comum/components/LoadingImage";
import ExportarExcelMovimentacao from '../components/ExportarExcelMovimentacao';


@inject("store")
@DataWrapper
@observer
export class Movimentacao extends Component {

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.controller = new MovimentacaoStore();
        this.camposStore = new CamposExibicaoStore();

        this.handleClickFilter = this.handleClickFilter.bind(this)
        this.handleCancelFilters = this.handleCancelFilters.bind(this)
        this.handleOpenFilters = this.handleOpenFilters.bind(this)
    }

    componentDidMount() {
        process.env.rig ? this.tituloPaginaStore.setTitulo("Movimentação") : this.tituloPaginaStore.setTitulo("Movimentação de Containers");
        this.appStore.showTopbar(true);
    }

    componentWillUpdate() {
        if(process.env.rig) {
            this.tituloPaginaStore.setTitulo(!this.controller.mostrarCamposExibicao ? "Movimentação" : "Customizar Visualização")
        } else {
            this.tituloPaginaStore.setTitulo(!this.controller.mostrarCamposExibicao ? "Movimentação de Containers" : "Customizar Visualização")
        }
    }

    handleClickFilter() {
        this.camposStore.salvarFiltro()
        this.camposStore.carregarCampos()
        this.controller.fecharPagCampos(this.camposStore.filtrosSalvos[this.camposStore.filtroSelecionado])
    }

    handleCancelFilters() {
        this.camposStore.cancerlarFiltros()
        this.controller.fecharSemSalvar()
    }

    handleOpenFilters() {
        this.camposStore.carregarCampos()
        this.controller.clickCampos()
    }

    render() {

        const modalAviso = (
            <ModalAviso onClickFechar={ this.camposStore.sairModalLimite } >
                <h2>Opa! Limite ultrapassado.</h2>
                <p><label className="label-disabled">Você selecionou mais de <b>10 itens</b> <br></br> para exibir como Dados da tabela</label> </p>
                <p><label className="label-disabled"><span className="label-primary">Dica:</span> marque apenas os itens que <br></br> são importantes para você</label> </p>
            </ModalAviso>
        )
        const pdfData = this.controller.todasColunas.filter(elem => this.controller.camposTabela.indexOf(elem.dataField) !== -1)
        const pdfDataTime = pdfData.filter(elem => elem.formatter && elem.formatter.name === 'formatarDataMov')
        return(
            <div>
                <div className="form-wrapper">
                        {
                            !this.controller.mostrarCamposExibicao
                            ?
                            <Container fluid>
                                <FiltrosMovimentacao clickBtnFiltros={this.handleOpenFilters} controller={this.controller}/>
                                <TabelaMovimentacao controller={this.controller} />
                            </Container>
                            :
                            <JanelaFiltros
                                closeAction = {this.handleClickFilter}
                                cancelButAction = {this.handleCancelFilters}
                                controller = {this.camposStore}
                                fields = {['rowCards','checkbox']}
                                checkboxItems = {check}
                                rowCardsItems = {cards}
                                editName = {this.camposStore.mostrarEditarFiltroNome}
                                showWarningModal = {this.camposStore.limiteCamposAtingido}
                                warningModal = {modalAviso}
                            />
                        }
                </div>
                {!this.controller.mostrarCamposExibicao &&
                <Footer>
                    <FooterContent>
                        {this.controller.total !== null &&
                            <div className="justify-content-between">
                                <div>
                                    <b>{this.controller.total}</b> {this.controller.total === 1 ? 'registro' : 'registros'} - 
                                    <a onClick={() => this.controller.pesquisar()}>Atualizar Lista</a>
                                </div>
                            </div>
                        }
                    </FooterContent>
                    

                    {<FooterOptions>
                        <div>
                            <IconButton
                                icon="file-pdf"
                                text="Baixar PDF"
                                size="md"
                                disabled={this.controller.listaItens.length > 0 ? false : true}
                                onClick={
                                    () => makePDF(
                                        this.controller.listaItens,
                                        pdfData.map(elem => elem.dataField),
                                        pdfData.map(elem => elem.text),
                                        pdfDataTime.map(elem => elem.dataField),
                                        true,
                                        false
                                    )
                                }
                            />
                        </div>
                        <div>
                            <ExportarExcelMovimentacao controller = {this.controller} />
                        </div>
                    </FooterOptions>}
                </Footer>}
            </div>
        );
    }
}

const check = {
    titulo: "Dados da tabela",
    itens: "todosCampos",
    itensAtivos: "camposAtivos",
    itensRequeridos: "camposObrigatorios",
    onClickItem: "clickCheckboxCampo",
    selecionarTudo:"selecionarTodosOsCampos",
    limparTudo:"limparTodosOsCampos"
}

const cards = {
    titulo: "Predefinições",
    container: "filtrosSalvos",
    ativo: "filtroSelecionado",
    onClick: "clickFiltro",
    editarClick: "editarFiltroNomeClick",
    editCancel:"cancelarNovoNome",
    editSave: "salvarNovoNome",
    editLabels:[
        {
            label:"Nome",
            value:"nome",
            onChange:"mudarNomePred"
        },
        {
            label:"Descrição",
            value:"descricao",
            onChange:"mudarDescPred"
        }
    ]
}



// WEBPACK FOOTER //
// ./src/modules/consultas/movimentação/tela/Movimentacao.js